import React, { useState, useEffect, Fragment } from 'react'
import styled, { css } from 'styled-components'
import GamesService from 'common/Services/GamesService'
import { BACKGROUNDS, COLORS } from 'themes'
import device from 'utils/mediaQueries'
import Text from 'ui/Text'
import { JackpotWrapper } from 'ui/JackpotWrapper'
import getTexts from 'utils/localization'
import propTypes from 'prop-types'
import CardImage from 'ui/CardImage'
import { LiveCasinoGameCard } from '@bet25/live-casino'
import NotificationConductor from 'common/conductors/NotificationConductor'

const CardWrapper = styled.div`
    position: relative;
    ${({ gridItem }) => (gridItem ? 'display: inline-block' : null)};
    float: ${({ float }) => (float ? float : 'none')};
    transition: all 0.3s ease;
    padding: 0 5px;
    box-sizing: border-box;
    width: 25%;
    max-width: 25%;
    margin: 0 0 11px 0;
    height: auto;

    @media screen and ${device.xxl} {
        max-width: 33%;
        width: 33%;
    }
    @media screen and ${device.xl} {
        max-width: 33%;
        width: 33%;
    }
    @media screen and ${device.md} {
        max-width: 50%;
        width: 50%;
    }
    @media screen and ${device.sm} {
        max-width: 50%;
        width: 50%;
    }
    ${(props) =>
        props.fadeGame &&
        css`
            //pointer-events: none;
            //cursor: default;

            &:before {
                content: '';
                width: 100%;
                height: 100%;
                display: block;
                position: absolute;
                background: #000;
                opacity: 0.6;
                z-index: 2;
            }
        `};
`
const GameWrapper = styled.div``

const GameCard = (props) => {
    const [game, setGame] = useState(props.game)
    const isLiveCasino = game.category === 'liveint'

    const chooseGame = () => {
        GamesService.updateMultipleGames(props.index, game)
        GamesService.setMinimizedGames(game)
    }

    const gameClickHandler = () => {
        if (isLiveCasino) {
            NotificationConductor.warning(
                `Live Casino er ikke tilgængeligt i Multivisning`
            )
        } else {
            if (!props.fadeGame) {
                chooseGame()
            } else {
                NotificationConductor.warning(
                    `Spillet er allerede åbent i multivisning`
                )
            }
        }
    }

    return (
        <CardWrapper {...props} size={'x1'} onClick={gameClickHandler}>
            {!isLiveCasino ? (
                <GameWrapper>
                    <CardImage game={props.game} />
                    {game.jackpot_amount_formatted ? (
                        <JackpotWrapper size={'sm'}>
                            <Text white>
                                {game.jackpot_amount_formatted} kr.
                            </Text>
                        </JackpotWrapper>
                    ) : null}
                </GameWrapper>
            ) : (
                <LiveCasinoGameCard
                    themeName={'go'}
                    thumbSize={'M'}
                    game={game}
                    height={'100%'}
                    showTitle={false}
                    withHoverScale={false}
                    gameClickHandler={() =>
                        Notification.warning(
                            `You can't run LiveCasino games in multiple mode`
                        )
                    }
                />
            )}
        </CardWrapper>
    )
}

GameCard.propTypes = {
    game: propTypes.object,
    index: propTypes.number,
    size: propTypes.string,
    fadeGame: propTypes.bool,
}

export default GameCard
